import navigation from "@/lang/ru/navigation";
import generics from "@/lang/ru/generics";
import questions from "@/lang/ru/questions";
import a11y from "@/lang/ru/a11y";
import velt from "@/lang/ru/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
